const DEPOSIT_SOURCE = Object.freeze({
  online: 'online',
  card: 'card',
  cash: 'cash',
  other: 'other',
  pos: 'slick_pos',
});

// noinspection JSUnusedGlobalSymbols
export default DEPOSIT_SOURCE;
